// extracted by mini-css-extract-plugin
export var bannerTitle = "subscribe-banner-module--bannerTitle--53348";
export var bannerWrapper = "subscribe-banner-module--bannerWrapper--bc37b";
export var buttonStyle = "subscribe-banner-module--buttonStyle--c9e1e";
export var genericContainer = "subscribe-banner-module--genericContainer--fbe07";